module.exports = __webpack_public_path__ + "img/3.d70b6ab8.png";